/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = BEGINSWITH 1 = ENDSWITH 2 = CONTAINS 3 = CONTAINSWORD 4 = STRMATCH 5 = EQ 6 = GE 7 = GT 8 = LE 9 = LT 12 = WITHIN 14 = RX 15 = STREQ 17 = DETECTSQLI 18 = DETECTXSS
 */
export type WafRuleOperatorType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 12 | 14 | 15 | 17 | 18;

export const WafRuleOperatorType = {
  BEGINSWITH: 0 as WafRuleOperatorType,
  ENDSWITH: 1 as WafRuleOperatorType,
  CONTAINS: 2 as WafRuleOperatorType,
  CONTAINSWORD: 3 as WafRuleOperatorType,
  STRMATCH: 4 as WafRuleOperatorType,
  EQ: 5 as WafRuleOperatorType,
  GE: 6 as WafRuleOperatorType,
  GT: 7 as WafRuleOperatorType,
  LE: 8 as WafRuleOperatorType,
  LT: 9 as WafRuleOperatorType,
  WITHIN: 12 as WafRuleOperatorType,
  RX: 14 as WafRuleOperatorType,
  STREQ: 15 as WafRuleOperatorType,
  DETECTSQLI: 17 as WafRuleOperatorType,
  DETECTXSS: 18 as WafRuleOperatorType,
};
